module.exports = __webpack_public_path__ + "04811a743374b40710755e258a67ae7e.png";